export default function importModule(name, loader, styles, scope = document) {
  const selector = `[data-module="${name}"]`;

  // Collect matches within the scope (plus the scope element itself when it is
  // the module root — e.g. an ACF block preview whose wrapper IS the module).
  const found = Array.from(scope.querySelectorAll(selector));
  if (scope.nodeType === 1 && typeof scope.matches === 'function' && scope.matches(selector)) {
    found.unshift(scope);
  }

  // Skip elements already initialized so re-runs (Gutenberg/ACF re-render block
  // previews after DOMContentLoaded and on every edit) don't double-init.
  const el = found.filter((node) => node.dataset.modInit !== 'true');

  if (el.length === 0) {
    return Promise.resolve();
  }

  el.forEach((node) => {
    node.dataset.modInit = 'true';
  });

  if (styles) {
    styles();
  }

  if (loader) {
    return loader().then((module) => {
      return {
        module: module.default,
        el,
      };
    });
  }
}
